import * as React from "react"
import { Box } from "@mui/material"
import { formatProductsUnits } from "@ui-seeker/utils"

import { HierarchicalTextBlock, ImageSkuBlock, ShowDetails } from "@components"
import { CategoryText, SkuInfoBlockWrap } from "../@components"
import { useAdminProductReviewTable } from "../../../@hooks"


export default function productRawColumn(hideNumItems=false) {
	return [{
		name: 'productID', label: 'Product ID',
		options: { filterType: "textField", display: 'excluded' }
	}, {
		name: 'repeatedSku', label: 'Repeated SKU',
		options: {
			filterType: "checkbox", display: 'excluded',
			customBodyRowRender: value => value ? 'YES' : 'NO'
		}
	}, {
		name: 'brandRaw', label: 'Brand Raw',
		options: { filterType: "textField", display: 'excluded' }
	}, {
		name: 'sellerName', label: 'Seller Name',
		options: { display: 'excluded' }
	}, {
		name: "productName", label: "Product Raw",
		options: {
			filterType: 'textField',
			customBodyRowRenderLite: (value, rowData) => <ProductRowCell productName={value} rowData={rowData} hideNumItems={hideNumItems} />
		}
	}]
}

const ProductRowCell = ({ productName, rowData, hideNumItems }) => {
	const { rowItemsClicked, rowDetailsClicked, handleDetailsRowClick, handleItemsRowClick } = useAdminProductReviewTable(rowData)

	const isOpenItemsClass = rowItemsClicked ? 'is-open-num-items' : ''
	const isOpenDetailsClass = rowDetailsClicked ? 'is-open' : ''

	const numItems = rowData.details?.length
	const showNumItems = numItems > 1

	const repeatedSkuColor = rowData.repeatedSku ? 'success' : 'error'
	const repeatedSkuLabel = rowData.repeatedSku ? 'yes' : 'no'

	const validatedColor = rowData.validated ? 'success' : 'error'
	const validatedLabel = rowData.validated ? 'yes' : 'no'

	const imageURL = rowData.thumbnail
	
	return <Box className={`${isOpenDetailsClass} ${isOpenItemsClass}`} sx={{ display: 'flex', alignItems: 'center' }}>
		<ImageSkuBlock imageURL={imageURL} name={productName} hideName imageProps={{ minWidth: 50, minHeight: 50 }} contentProps={{ sx: {margin: '', mr: 3} }} />
		<Box sx={{ display: 'flex', flexDirection: 'column' }}>
			{!!showNumItems && !hideNumItems && <Box onClick={() => {
				handleItemsRowClick()
				setTimeout(() => {
					scrollToComponent('product-review-details-table')
				}, 1)
			}}>
				<HierarchicalTextBlock
					title="Nº Items: "
					titleValue={formatProductsUnits(numItems)}
					sx={{ textDecoration: 'underline', cursor: 'pointer' }}
				/>
			</Box>}
			<HierarchicalTextBlock title="Product ID: " titleValue={rowData.productID} />
			<HierarchicalTextBlock title="Repeated SKU: " titleValue={<CategoryText label={repeatedSkuLabel} color={repeatedSkuColor}  />} />
			<HierarchicalTextBlock title="Brand Raw: " titleValue={rowData.brandRaw} />
			<HierarchicalTextBlock title="Validated SKU: " titleValue={<CategoryText label={validatedLabel} color={validatedColor}  />} />
			{ !!rowData.sellerName && <HierarchicalTextBlock title="Seller Name: " titleValue={rowData.sellerName}/>}
			<SkuInfoBlockWrap url={rowData.productURL} sku={productName} category={rowData.category} brand={rowData?.skuBrand} />

			<ShowDetails onClick={handleDetailsRowClick}/>
		</Box>
	</Box>
}